// extracted by mini-css-extract-plugin
export default {"recommendations_container":"styles_recommendations_container__y+h+l","recommendations_container_for_print":"styles_recommendations_container_for_print__yMfdg"};